import React from 'react';
import styles from './sections.module.css';
import { useScrollReveal } from '../hooks/useScrollReveal';

interface ParticipationSectionProps {
  participation: any;
}

export const ParticipationSection: React.FC<ParticipationSectionProps> = ({ participation }) => {
  const ref = useScrollReveal();
  if (!participation) return null;

  const events = participation.events || [];

  return (
    <section id="participation" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>{participation.heading || 'Denk en doe mee'}</h2>
        {participation.image && (
          <div className={styles.sectionImage}>
            <img src={participation.image} alt={participation.heading || 'Participatie'} />
          </div>
        )}
        {participation.body && (
          <div className={styles.participationText}>
            {participation.body.split('\n').map((p: string, i: number) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        )}
        {events.length > 0 && (
          <div className={styles.eventsGrid}>
            {events.map((event: any, i: number) => (
              <div key={i} className={styles.eventCard}>
                <div className={styles.eventDate}>
                  {event.date && new Date(event.date).toLocaleDateString('nl-NL', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                  })}
                </div>
                <h4 className={styles.eventTitle}>{event.title}</h4>
                {event.location && (
                  <span className={styles.eventLocation}>{event.location}</span>
                )}
                {event.description && <p className={styles.eventDesc}>{event.description}</p>}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
